module.exports = __webpack_public_path__ + "static/media/icon2.cd7d3b90.svg";